import { Routes, Route, NavLink, Link } from 'react-router-dom';
import Home from './pages/Home';
import Services from './pages/Services';
import Fleet from './pages/Fleet';
import Insurance from './pages/Insurance';
import Booking from './pages/Booking';
import NotFound from './pages/NotFound';
import SocialTopBar from "./components/SocialTopBar";
import { FaInstagram, FaFacebookF, FaLinkedinIn } from "react-icons/fa";


const BRAND = { name: 'BISITELLA TRANSPORTATION LLC', phone: '+1 (555) 123-4567' };

export default function App() {
  return (
    <div className="d-flex flex-column min-vh-100">
      {/* Navbar */}
      <SocialTopBar />
      <nav className="navbar navbar-expand-lg navbar-light bg-white border-bottom sticky-top">
        <div className="container">
          <Link to="/" className="navbar-brand d-flex align-items-center gap-2">
            <img src="/images/bisitella-logo.jpg" alt="Bisitella logo" height="50" />
            <strong className='text-danger'>{BRAND.name}</strong>
          </Link>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#mainNav">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="mainNav">
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
              <li className="nav-item"><NavLink to="/services" className="nav-link">Services</NavLink></li>
              <li className="nav-item"><NavLink to="/fleet" className="nav-link">Fleet</NavLink></li>
              <li className="nav-item"><NavLink to="/insurance" className="nav-link">Insurance</NavLink></li>
              <li className="nav-item"><NavLink to="/booking" className="btn btn-primary ms-lg-2">Book a Ride</NavLink></li>
            </ul>
          </div>
        </div>
      </nav>

      {/* Routes */}
      <main className="flex-grow-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/fleet" element={<Fleet />} />
          <Route path="/insurance" element={<Insurance />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      {/* Footer */}
<footer className="text-light mt-5 pt-5 bg-primary">
  <div className="container">
    <div className="row g-4 align-items-start">
      <div className="col-12 col-md-4">
        <h5 className="text-white mb-2">{BRAND.name}</h5>
        <p className="text-white-50 mb-3">
          Compassionate, reliable non-emergency medical transportation.
        </p>

        {/* Social icons in footer */}
        <div className="d-flex align-items-center gap-2">
          <a
            href="https://instagram.com/yourhandle"
            target="_blank" rel="noreferrer"
            className="social-footer" aria-label="Instagram" title="Instagram"
          ><FaInstagram size={18} /></a>

          <a
            href="https://facebook.com/yourpage"
            target="_blank" rel="noreferrer"
            className="social-footer" aria-label="Facebook" title="Facebook"
          ><FaFacebookF size={18} /></a>

          <a
            href="https://www.linkedin.com/company/yourcompany"
            target="_blank" rel="noreferrer"
            className="social-footer" aria-label="LinkedIn" title="LinkedIn"
          ><FaLinkedinIn size={18} /></a>
        </div>
      </div>

      <div className="col-6 col-md-2">
        <h6 className="text-white">Links</h6>
        <ul className="list-unstyled">
          <li><Link className="link-light" to="/services">Services</Link></li>
          <li><Link className="link-light" to="/fleet">Fleet</Link></li>
          <li><Link className="link-light" to="/insurance">Insurance</Link></li>
          <li><Link className="link-light" to="/booking">Booking</Link></li>
        </ul>
      </div>

      <div className="col-12 col-md-6">
        <h6 className="text-white">Contact</h6>
        <p className="mb-1"><strong>Phone : </strong> +1 (651) 283-7169</p>
        <p className="mb-1"><strong>Email : </strong> info@bisitellatransport.com</p>
        <p className="mb-3"><strong>Hours : </strong> 24/7</p>
      </div>
    </div>

    <hr className="border-light opacity-50" />
    <div className="text-center pb-3 small text-white-50">
      © {new Date().getFullYear()} {BRAND.name}. All rights reserved.
    </div>
  </div>
</footer>

    </div>
  );
}
